/** @format */

import {FormState} from './types';

export const DEFAULT_VALUES: FormState = {
  name: '',
  email: '',
  position: '',
  companyIds: [],
};
